import { useEffect, useState } from 'react';
import 'react-multi-carousel/lib/styles.css';
import { Progress } from 'antd';
import { Row, Col } from 'react-bootstrap';
import './index.scss';
import SwapComponent from '../../components/SwapComponent';
import {
  Address,
  AddressValue,
  ContractFunction,
  Query
} from '@multiversx/sdk-core/out';
import Moment from 'react-moment';
import {
  TIMEOUT,
  VESTING_CONTRACT_ADDRESS,
  VESTING_TOKEN_DECIMAL,
  TOTAL_MILESTONE_AMOUNT,
  COUNTDOWN_FINISHED_MESSAGE
} from 'config';
import {
  useGetNetworkConfig,
  useGetPendingTransactions,
  useGetAccountInfo
} from '@multiversx/sdk-dapp/hooks';
import { ProxyNetworkProvider } from '@multiversx/sdk-network-providers/out';
import { convertWeiToEgld } from 'utils/convert';
import Countdown from 'react-countdown';

export const Sale = () => {
  const { network } = useGetNetworkConfig();
  const [percent, setPercent] = useState(0);
  const { hasPendingTransactions } = useGetPendingTransactions();
  const [subscribbedSupply, setSubscribbedSupply] = useState(0);
  const [milestoneTotalSupply, setMilestoneTotalSupply] = useState(10000000);
  const {
    address,
    account: { balance }
  } = useGetAccountInfo();
  const [startTimestamp, setStartTimestamp] = useState(0);
  const [endTimestamp, setEndTimestamp] = useState(0);

  const [percentBought, setPercentBought] = useState(0);
  const [boughtAmount, setBoughtAmount] = useState(0);

  useEffect(() => {
    (async () => {
      // token balance in sc
      const query = new Query({
        address: new Address(VESTING_CONTRACT_ADDRESS),
        func: new ContractFunction('getUserVestingAmountAll'),
        args: [new AddressValue(new Address(address))]
      });
      const proxy = new ProxyNetworkProvider(network.apiAddress, {
        timeout: TIMEOUT
      });

      try {
        const { returnData } = await proxy.queryContract(query);
        const [encoded] = returnData;
        if (encoded == undefined || encoded == '') {
          setBoughtAmount(0);
        } else {
          const decoded = Buffer.from(encoded, 'base64').toString('hex');
          const value = convertWeiToEgld(
            parseInt(decoded, 16),
            VESTING_TOKEN_DECIMAL
          );
          console.log('getUserVestingAmountAll: ', value);
          setBoughtAmount(value);
          setPercentBought((Number(value) / TOTAL_MILESTONE_AMOUNT) * 100);
        }
      } catch (e: any) {
        console.error('Unable to call VM query', e);
      }
    })();

    (async () => {
      // token balance in sc
      const query = new Query({
        address: new Address(VESTING_CONTRACT_ADDRESS),
        func: new ContractFunction('getTotalVestingAmount')
      });
      const proxy = new ProxyNetworkProvider(network.apiAddress, {
        timeout: TIMEOUT
      });

      try {
        const { returnData } = await proxy.queryContract(query);
        const [encoded] = returnData;
        if (encoded == undefined || encoded == '') {
          setSubscribbedSupply(0);
        } else {
          const decoded = Buffer.from(encoded, 'base64').toString('hex');
          const value = convertWeiToEgld(
            parseInt(decoded, 16),
            VESTING_TOKEN_DECIMAL
          );
          //console.log('getTotalVestingAmount: ', value);
          const milestoneSubscribbedSupply = value - 21093548;
          const milestone = milestoneTotalSupply;

          setSubscribbedSupply(Math.floor(milestoneSubscribbedSupply));
          setPercent((Number(milestoneSubscribbedSupply) / milestone) * 100);
        }
      } catch (e: any) {
        console.error('Unable to call VM query', e);
      }
    })();

    (async () => {
      // token balance in sc
      const query = new Query({
        address: new Address(VESTING_CONTRACT_ADDRESS),
        func: new ContractFunction('getSaleStartTimestamp')
      });
      const proxy = new ProxyNetworkProvider(network.apiAddress, {
        timeout: TIMEOUT
      });

      try {
        const { returnData } = await proxy.queryContract(query);
        const [encoded] = returnData;
        if (encoded == undefined || encoded == '') {
          setSubscribbedSupply(0);
        } else {
          const decoded = Buffer.from(encoded, 'base64').toString('hex');
          const value = parseInt(decoded, 16);
          setStartTimestamp(value);
        }
      } catch (e: any) {
        console.error('Unable to call VM query', e);
      }
    })();

    (async () => {
      // token balance in sc
      const query = new Query({
        address: new Address(VESTING_CONTRACT_ADDRESS),
        func: new ContractFunction('getSaleEndTimestamp')
      });
      const proxy = new ProxyNetworkProvider(network.apiAddress, {
        timeout: TIMEOUT
      });

      try {
        const { returnData } = await proxy.queryContract(query);
        const [encoded] = returnData;
        if (encoded == undefined || encoded == '') {
          setSubscribbedSupply(0);
        } else {
          const decoded = Buffer.from(encoded, 'base64').toString('hex');
          const value = parseInt(decoded, 16);
          setEndTimestamp(value);
        }
      } catch (e: any) {
        console.error('Unable to call VM query', e);
      }
    })();
  }, [hasPendingTransactions]);

  return (
    <div className='container'>
      <div className='main-banner no-overlay'>
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <h3>EVLD</h3>
              <h1>SALE</h1>
            </div>
          </div>
        </div>
      </div>
      <div className='general-content'>
        <div className='gc-corners'>
          <svg x='0px' y='0px' viewBox='0 0 181 45' className='gc-tl'>
            <path
              className='st0'
              fill='#333C54'
              d='M0,45V12.2C0,5.5,5.4,0,12.2,0h124c6.5,0,12.7,3,16.7,8.2L181,45H0z'
            />
          </svg>
          <svg x='0px' y='0px' viewBox='0 0 181 45' className='gc-tr'>
            <path
              className='st0'
              fill='#333C54'
              d='M181,45V12.2C181,5.5,175.6,0,168.8,0l-124,0c-6.5,0-12.7,3-16.7,8.2L0,45H181z'
            />
          </svg>
          <svg x='0px' y='0px' viewBox='0 0 181 45' className='gc-bl'>
            <path
              className='st0'
              fill='#333C54'
              d='M0,0l0,32.8C0,39.5,5.4,45,12.2,45h124c6.5,0,12.7-3,16.7-8.2L181,0L0,0z'
            />
          </svg>
          <svg x='0px' y='0px' viewBox='0 0 181 45' className='gc-br'>
            <path
              className='st0'
              fill='#333C54'
              d='M181,0v32.8c0,6.7-5.4,12.2-12.2,12.2h-124c-6.5,0-12.7-3-16.7-8.2L0,0H181z'
            />
          </svg>
        </div>

        <div className='d-none justify-content-center m-5'>
          <h4>BATCH 3/3</h4>
        </div>

        <div className='evoload-timer'>
          <h3 className='ml-0'>BUY EVLD</h3>
          <div className='mr-0 ml-auto'>
            {startTimestamp > Date.now() / 1000 && (
              <h6>
                Countdown:
                <Countdown date={startTimestamp * 1000} className='ml-2' />
              </h6>
            )}

            {startTimestamp < Date.now() / 1000 &&
              endTimestamp > Date.now() / 1000 && (
                <h6>
                  Countdown:
                  <Countdown date={endTimestamp * 1000} className='ml-2' />
                </h6>
              )}

            {endTimestamp < Date.now() / 1000 && (
              <h6 className='text-danger font-weight-bold'>
                {COUNTDOWN_FINISHED_MESSAGE}
              </h6>
            )}
          </div>
        </div>

        <div className='progress-wrapper'>
          {address ? (
            <div className='col-12 px-0'>
              <div className='w-100 d-inline-block d-lg-flex mb-1'>
                <div className='progress-bar-percent ms-0 mr-auto'>
                  <h6>
                    <b>My progress: {percentBought.toFixed(2)}%</b>
                  </h6>
                </div>
                <div className='progress-sold ms-auto mr-0'>
                  <h6>
                    <b>
                      Purchased: {Number(boughtAmount.toFixed(2))}{' '}
                      <span style={{ display: 'none' }}>
                        / {TOTAL_MILESTONE_AMOUNT} EVLD
                      </span>
                    </b>
                  </h6>
                </div>
              </div>
              <Progress percent={percentBought} showInfo={false} />

              <div
                style={{ display: 'none' }}
                className='bonus-milestones mt-4'
              >
                <h4 className='my-2'>NOTE</h4>
                <ul className='simple-list tiers-list'>
                  <li className='add-sl-steps mt-0 mb-0 mb-lg-2'>
                    <h6 className='pl-0 pr-0'>
                      <b>
                        ⚠️ At over $10.000 buy in Pre-Sale 1 you get 1{' '}
                        <a
                          href='https://evoload.co/nft.html#platinum-nft'
                          style={{ color: '#005DFF' }}
                          target='_blank'
                        >
                          <b>Platinum NFT</b>
                        </a>{' '}
                        - limited to 6 pcs.
                      </b>{' '}
                    </h6>
                  </li>
                </ul>
              </div>
            </div>
          ) : (
            <div className='col-12 px-0'>
              <div className='w-100 d-inline-block d-lg-flex mb-1'>
                <div className='progress-bar-percent ms-0 mr-auto'>
                  <h6>
                    <b>Total progress: {percent.toFixed(2)}%</b>
                  </h6>
                </div>
                <div className='progress-sold ms-auto mr-0'>
                  <h6>
                    <b>
                      Sold:{' '}
                      {subscribbedSupply > 999999
                        ? subscribbedSupply.toString().slice(-9, -6) + '.'
                        : ''}
                      {`${subscribbedSupply
                        .toString()
                        .slice(-6, -3)}.${subscribbedSupply
                        .toString()
                        .slice(-3)}`}{' '}
                      /{' '}
                      {`${milestoneTotalSupply
                        .toString()
                        .slice(0, 2)}.${milestoneTotalSupply
                        .toString()
                        .slice(2, 5)}.${milestoneTotalSupply
                        .toString()
                        .slice(5, 8)}`}{' '}
                      EVLD
                    </b>
                  </h6>
                </div>
              </div>

              <Progress percent={percent} showInfo={false} />
            </div>
          )}
        </div>
        <div className='swap-component-wrapper mt-5'>
          <SwapComponent endTimestamp={endTimestamp} />
        </div>
      </div>
    </div>
  );
};
